module.exports = __webpack_public_path__ + "media/A_L19.d66821b2.mp3";